<script>
import { h } from 'vue';
import EditableComponent from './EditableComponent';
import { buildKey, insertComments } from "./helper";
import EditorContextHelper from './EditorContextHelper';

const EditableArea = {
  name: 'EditableArea',
  components: {
    EditableComponent
  },
  inject: ['config', 'templateAnnotations'],
  props: {
    content: {
      type: Object
    },
    parentTemplateId: {
      type: String,
      required: false
    },
    elementType: {
      type: String,
      default: 'div'
    },
    customView: {
      type: Object
    }
  },
  methods: {
    writeAnnotation() {
      if (!this.content) {
        return;
      }
      if (this.templateAnnotations.value && this.templateAnnotations.value[this.content['@path']]) {
        const commentOpen = this.templateAnnotations.value[this.content['@path']];
        insertComments(this.$el, commentOpen, '/cms:area');
        EditorContextHelper.refresh();
      }
    }
  },
  async mounted() {
    if (await EditorContextHelper.inEditorAsync()) {
      this.writeAnnotation();
    }
  },
  render() {
    if (!this.content) {
      return null;
    }
    const componentContents = this.content['@nodes'].map((nodeName) => this.content[nodeName]);
    let childComponents = [];
    if (this.$slots.default) {
      return h(this.elementType, null, this.$slots.default({ content: this.content }));
    }
    childComponents = componentContents.map((node, index) =>
      h(EditableComponent, { content: node, key: buildKey(node), index }, null)
    );

    return h(
      this.elementType,
      null,
      this.customView
        ? h(this.customView, {
            content: this.content,
            key: buildKey(this.content)
          })
        : childComponents
    );
  }
};

export default EditableArea;
</script>
